<template>
<div class="settings">
    <div class="columns">
        <div class="column is-one-quarter">
            <div class="columns">
                <div class="column is-11">
                    <settings-menu active-item="storages"></settings-menu>
                </div>
            </div>
        </div>
        <div class="column">
            <div class="settings-container">
                <div class="columns">
                    <div v-if="loadingStorage" class="column is-full has-text-centered">
                        <img src="/loader-dark.svg">
                    </div>
                    <div v-if="!loadingStorage" class="column is-full">
                        <div v-if="storage" class="columns is-multiline">
                            <div class="column is-10">
                                <div class="plan-page-label cursor-pointer">
                                    <div class="dropdown is-left is-hoverable dropdown-trigger">
                                        <font-awesome-icon icon="hdd"/><span style="display: inline-block; margin-top: -4px;">&nbsp;&nbsp;{{ 'Storage: ' + storage.name }}</span>
                                        <div class="dropdown-menu" role="menu">
                                            <div class="dropdown-content">
                                                <a @click="makeStorageDefault" :class="{ 'has-text-grey-lighter cursor-not-allowed': storage.is_default }" class="dropdown-item">
                                                    <span><font-awesome-icon icon="hdd" class="dropdown-action-icon"/>&nbsp;&nbsp;Make Storage as default</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="plan-page-description" style="font-size:13px !important; margin-top: 0px;">{{ providerInfo }}</div>
                            </div>
                            <div class="column is-2 has-text-right">
                                <span v-if="storage.is_default" class="tag is-success is-small">Default Storage</span>
                            </div>

                            <div class="column is-12">
                                <div class="columns is-multiline">
                                    <div v-if="storage.is_provided" class="column is-full">
                                        <div class="notification is-info" style="font-size: 13px;">
                                            This storage is provided by Weap.io and can be used to store your Database backups. Feel free to replace or extend it by connecting your own cloud storages.
                                        </div>
                                    </div>
                                    <div class="column is-full">
                                        <div v-if="providerIsS3Based" class="columns is-multiline">
                                            <div class="column is-6">
                                                <div class="field">
                                                    <input v-model="name" type="text" @keyup.enter="updateStorage" :class="{ 'is-danger': hasError('name') }" class="input custom-input-size is-medium" placeholder="Friendly name" autocomplete="off" :disabled="nameIsDisabled"/>
                                                    <span v-if="!hasError('name')" class="help">A name to easily recognize the account later</span>
                                                    <span v-if="hasError('name')" class="help is-danger">{{ getError('name') }}</span>
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <div class="field">
                                                    <input v-model="bucketName" type="text" @keyup.enter="updateStorage" :class="{ 'is-danger': hasError('bucket_name') }" class="input custom-input-size is-medium" placeholder="Bucket name" autocomplete="off" :disabled="bucketNameIsDisabled"/>
                                                    <span v-if="!hasError('bucket_name')" class="help">In this bucket the backups will be stored</span>
                                                    <span v-if="hasError('bucket_name')" class="help is-danger">{{ getError('bucket_name') }}</span>
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <div class="field">
                                                    <input type="text" v-model="accessKey" @keyup.enter="updateStorage" :class="{ 'is-danger': hasError('access_key') }" class="input custom-input-size is-medium" placeholder="Access Key ID" autocomplete="off" :disabled="accessKeyIsDisabled"/>
                                                    <span v-if="!hasError('access_key')" class="help">Access Key ID</span>
                                                    <span v-if="hasError('access_key')" class="help is-danger">{{ getError('access_key') }}</span>
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <div class="field">
                                                    <input type="text" v-model="secretKey" @keyup.enter="updateStorage" :class="{ 'is-danger': hasError('secret_key') }" class="input custom-input-size is-medium" placeholder="Access Key Secret" autocomplete="off" :disabled="accessSecretIsDisabled"/>
                                                    <span v-if="!hasError('secret_key')" class="help">Access Key Secret</span>
                                                    <span v-if="hasError('secret_key')" class="help is-danger">{{ getError('secret_key') }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else-if="providerIsAzureblob" class="columns is-multiline">
                                            <div class="column is-6">
                                                <div class="field">
                                                    <input v-model="name" type="text" @keyup.enter="updateStorage" :class="{ 'is-danger': hasError('name') }" class="input custom-input-size is-medium" placeholder="Friendly name" autocomplete="off" :disabled="nameIsDisabled"/>
                                                    <span v-if="!hasError('name')" class="help">A name to easily recognize the storage account later.</span>
                                                    <span v-if="hasError('name')" class="help is-danger">{{ getError('name') }}</span>
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <div class="field">
                                                    <input v-model="azureblobAccount" @keyup.enter="updateStorage" type="text" :disabled="updatingStorage" :class="{ 'is-danger': hasError('azureblob_account') }" class="input custom-input-size is-medium" placeholder="Azure account" autocomplete="off"/>
                                                    <span v-if="!hasError('azureblob_account')" class="help">The name of the Azure Blob account.</span>
                                                    <span v-if="hasError('azureblob_account')" class="help is-danger">{{ getError('azureblob_account') }}</span>
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <div class="field">
                                                    <input v-model="azureblobAccessKey" @keyup.enter="updateStorage" type="text" :disabled="updatingStorage" :class="{ 'is-danger': hasError('azureblob_access_key') }" class="input custom-input-size is-medium" placeholder="Azure Access Key" autocomplete="off"/>
                                                    <span v-if="!hasError('azureblob_access_key')" class="help">Azure Blob Access Key</span>
                                                    <span v-if="hasError('azureblob_access_key')" class="help is-danger">{{ getError('azureblob_access_key') }}</span>
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <div class="field">
                                                    <input v-model="azureblobContainer" @keyup.enter="updateStorage" type="text" :disabled="updatingStorage" :class="{ 'is-danger': hasError('azureblob_container') }" class="input custom-input-size is-medium" placeholder="Azure Blob Container" autocomplete="off"/>
                                                    <span v-if="!hasError('azureblob_container')" class="help">Azure Blob Container</span>
                                                    <span v-if="hasError('azureblob_container')" class="help is-danger">{{ getError('azureblob_container') }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else-if="providerIsSftp" class="columns is-multiline">
                                            <div class="column is-6">
                                                <div class="field">
                                                    <input v-model="name" @keyup.enter="createStorage" type="text" :disabled="creatingStorage" :class="{ 'is-danger': hasError('name') }" class="input custom-input-size is-medium" placeholder="Friendly name" autocomplete="off"/>
                                                    <span v-if="!hasError('name')" class="help">A name to easily recognize the storage later.</span>
                                                    <span v-if="hasError('name')" class="help is-danger">{{ getError('name') }}</span>
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <div class="field">
                                                    <input v-model="sftpHost" @keyup.enter="createStorage" type="text" :disabled="creatingStorage" :class="{ 'is-danger': hasError('sftp_host') }" class="input custom-input-size is-medium" placeholder="SFTP host" autocomplete="off"/>
                                                    <span v-if="!hasError('sftp_host')" class="help">The host of the SFTP server.</span>
                                                    <span v-if="hasError('sftp_host')" class="help is-danger">{{ getError('sftp_host') }}</span>
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <div class="field">
                                                    <input v-model="sftpUsername" @keyup.enter="createStorage" type="text" :disabled="creatingStorage" :class="{ 'is-danger': hasError('sftp_username') }" class="input custom-input-size is-medium" placeholder="SFTP user" autocomplete="off"/>
                                                    <span v-if="!hasError('sftp_username')" class="help">The user of the SFTP server.</span>
                                                    <span v-if="hasError('sftp_username')" class="help is-danger">{{ getError('sftp_username') }}</span>
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <div class="field">
                                                    <input v-model="sftpPassword" @keyup.enter="createStorage" type="text" :disabled="creatingStorage" :class="{ 'is-danger': hasError('sftp_password') }" class="input custom-input-size is-medium" placeholder="SFTP password" autocomplete="off"/>
                                                    <span v-if="!hasError('sftp_password')" class="help">The password of the SFTP server.</span>
                                                    <span v-if="hasError('sftp_password')" class="help is-danger">{{ getError('sftp_password') }}</span>
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <div class="field">
                                                    <input v-model="sftpPort" @keyup.enter="createStorage" type="text" :disabled="creatingStorage" :class="{ 'is-danger': hasError('sftp_port') }" class="input custom-input-size is-medium" placeholder="SFTP port" autocomplete="off"/>
                                                    <span v-if="!hasError('sftp_port')" class="help">The port of the SFTP server.</span>
                                                    <span v-if="hasError('sftp_port')" class="help is-danger">{{ getError('sftp_port') }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="column is-full">
                                        <div class="columns is-multiline" style="margin-top: 10px;">
                                            <div class="column is-3">
                                                <div @click="updateStorage" :class="{ 'is-loading': this.updatingStorage }" class="button custom-button-size is-fullwidth is-info" :disabled="saveButtonIsDisabled">Save Changes</div>
                                            </div>
                                            <div class="column is-3 has-text-centered">
                                                <div :class="{ 'tooltip is-tooltip-multiline': notDeleteableReason }" :data-tooltip="notDeleteableReason">
                                                    <div @click="deleteStorage" class="close-add-monitor-modal button custom-button-size is-fullwidth is-danger" :disabled="!canBeDeleted">Delete Storage</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';
import Swal from 'sweetalert2';
import FormErrorsMixin from '@/mixins/FormErrors';

import SettingsMenu from '@/components/Settings/Menu.vue';

export default {
    components: {
        SettingsMenu,
    },

    mixins: [FormErrorsMixin],

    metaInfo: {
        title: 'Storage Settings - Weap.io',
    },

    data() {
        return {
            storage: null,
            name: '',
            bucketName: '',
            accessKey: '',
            secretKey: '',
            loadingStorage: false,
            updatingStorage: false,
            allowedInputs: [
                'name', 'access_key', 'secret_key', 'bucket_name',
                'azureblob_account', 'azureblob_access_key', 'azureblob_container',
                'sftp_host', 'sftp_username', 'sftp_password', 'sftp_port',
            ],
            azureblobAccount: '',
            azureblobAccessKey: '',
            azureblobContainer: '',
            sftpHost: '',
            sftpUsername: '',
            sftpPort: '',
            sftpPassword: '',
        }
    },

    mounted() {
        this.getStorage();
    },

    methods: {
        getStorage(successCallback) {
            if (this.loadingStorage) {
                return;
            }

            this.loadingStorage = true;

            Api().get('storages/' + this.$route.params.id)
                .then((response) => {
                    this.storage = response.data.data;
                    if (typeof successCallback == 'function') {
                        successCallback();
                    }
                })
                .catch((error) => {
                    //
                })
                .finally(() => {
                    this.loadingStorage = false;
                });
        },

        updateStorage() {
            if (this.updatingStorage) {
                return false;
            }

            this.updatingStorage = true;

            Api().put('storages/' + this.storage.id, this.storageData)
                .then((success) => {
                    this.resetErrors();
                    this.getStorage(() => {
                        swal('Success!', 'The storage was updated.', 'success');
                    });
                })
                .catch((error) => {
                    if (!this.storeErrors(error.response.data.errors)) {
                        if (typeof error.response.data.message == 'string') {
                            this.error = error.response.data.message;
                        } else {
                            this.error = 'Something wrong happened. Refresh the page and try again.';
                        }
                    }
                })
                .finally(() => {
                    this.updatingStorage = false;
                });
        },

        deleteStorage() {
            if (this.notDeleteableReason) {
                return;
            }
            
            swal({
                title: 'Are you sure?',
                text: 'The storage connection will be permanently removed. All the backups stored on this storage will not be deleted, you will have to manually delete them.',
                dangerMode: true,
                buttons: {
                    cancel: 'Cancel',
                    confirm: {
                        text: 'Yes, I\'m sure!',
                        value: true,
                        closeModal: false,
                    }
                },
                icon: 'warning',
            })
            .then((value) => {
                if (!value) {
                    swal.close();
                    return;
                }

                return Api().delete('storages/' + this.storage.id)
                    .then((success) => {
                        this.$router.push({ name: 'storagesSettings', query: { storage_deleted: true} });
                    });
            });
        },

        makeStorageDefault() {
            if (this.storage.is_default) {
                return;
            }

            swal({
                title: 'Are you sure?',
                text: 'From now on, this storage will be used as default for the new servers. Existent servers will not be affected by this change.',
                icon: 'info',
                buttons: {
                    cancel: 'Cancel',
                    confirm: {
                        text: 'Yes, make it default',
                        value: true,
                        closeModal: false,
                    }
                },
            })
            .then((value) => {
                if (!value) {
                    swal.close();
                    return;
                }

                return Api().put('storages/' + this.storage.id + '/is-default')
                    .then((success) => {
                        this.getStorage(() => {
                            swal('Success!', 'The default storage was changed.', 'success');
                        });
                    });
            });
        },

    },

    computed: {
        canBeDeleted() {
            if (this.updatingStorage) {
                return false;
            }

            if (this.storage.is_provided) {
                return false;
            }

            if (!this.storage.deleteable) {
                return false;
            }

            return true;
        },

        notDeleteableReason() {
            if (this.storage.is_provided) {
                return 'This storage is provided by Weap.io and cannot be deleted.';
            }

            if (!this.storage.deleteable) {
                if (this.storage.is_default) {
                    return 'This storage cannot be deleted because is the default one.';
                }

                return 'This storage cannot be deleted because it has active (or in progress) backups.';
            }
        },

        providerInfo() {
            var info = 'Provider: ' + this.storage.provider;
            
            if (!this.storage.is_provided && this.providerIsS3Based) {
                info += ' (' + this.storage.region + ')';
            }

            return info;
        },

        nameIsDisabled() {
            if (this.updatingStorage) {
                return true;
            }

            return false;
        },

        bucketNameIsDisabled() {
            return true;

            if (this.updatingStorage) {
                return true;
            }

            if (this.storage.is_provided) {
                return true;
            }

            return false;
        },

        accessKeyIsDisabled() {
            if (this.updatingStorage) {
                return true;
            }

            if (this.storage.is_provided) {
                return true;
            }

            return false;
        },

        accessSecretIsDisabled() {
            if (this.updatingStorage) {
                return true;
            }

            if (this.storage.is_provided) {
                return true;
            }

            return false;
        },

        saveButtonIsDisabled() {
            if (this.updatingStorage) {
                return true;
            }

            if (this.loadingStorage) {
                return true;
            }

            return false;
        },

        storageData() {
            var storage = {
                name: this.name,
                provider: this.storage.provider_slug,
            };

            if (this.storage.is_provided) {
                return storage;
            }

            if (this.providerIsS3Based) {
                storage.region = this.region;
                storage.access_key = this.accessKey;
                storage.secret_key = this.secretKey;
                storage.bucket_name = this.bucketName;

                return storage;
            }

            if (this.providerIsAzureblob) {
                storage.azureblob_account = this.azureblobAccount;
                storage.azureblob_access_key = this.azureblobAccessKey;
                storage.azureblob_container = this.azureblobContainer;
                return storage;
            }

            if (this.providerIsSftp) {
                storage.sftp_host = this.sftpHost;
                storage.sftp_username = this.sftpUsername;
                storage.sftp_port = this.sftpPort;
                storage.sftp_password = this.sftpPassword;
                return storage;
            }
        },

        providerIsS3Based() {
            return ['aws_s3', 'digitalocean_spaces', 'wasabi_s3', 'backblaze_b2_s3'].includes(this.storage.provider_slug);
        },

        providerIsAzureblob() {
            return this.storage.provider_slug == 'azureblob';
        },

        providerIsSftp() {
            return this.storage.provider_slug == 'sftp';
        }
    },

    watch: {
        storage(storage) {
            if (!storage) {
                return;
            }

            this.name = storage.name;

            if (this.providerIsS3Based) {
                this.bucketName = storage.bucket_name;
                this.accessKey = storage.access_key;
                this.secretKey = storage.secret_key;
            } else if (this.providerIsAzureblob) {
                this.azureblobAccount = storage.details.azureblob_account;
                this.azureblobAccessKey = storage.details.azureblob_access_key;
                this.azureblobContainer = storage.details.azureblob_container;
            } else if (this.providerIsSftp) {
                this.sftpHost = storage.details.sftp_host;
                this.sftpUsername = storage.details.sftp_username;
                this.sftpPassword = storage.details.sftp_password;
                this.sftpPort = storage.details.sftp_port;
            }
        },
    },  
}
</script>
